<!--Block the space if no form-field is provided. Otherwise it looks weird in the formly field inline representation.-->
@if (fieldControl()?.isFormCheck && !fieldset) {
  <div class="form-label"></div>
}
@if (fieldControl()?.isFormCheck) {
  <div class="form-item-content">
    <ng-container [ngTemplateOutlet]="content" />
    <ng-container [ngTemplateOutlet]="labelTemplate" />
    <ng-container [ngTemplateOutlet]="feedbackTemplate" />
  </div>
} @else {
  <ng-container [ngTemplateOutlet]="labelTemplate" />
  <div class="form-item-content">
    <ng-container [ngTemplateOutlet]="content" />
    <ng-container [ngTemplateOutlet]="feedbackTemplate" />
  </div>
}

<ng-template #labelTemplate>
  @if (label()) {
    <div
      class="d-flex gap-2 align-items-start"
      [class.form-label]="!fieldControl()?.isFormCheck"
      [class.form-check-label]="fieldControl()?.isFormCheck"
    >
      @let labeledBy = formItemLabelledBy;
      @let required = this.required() && !this.fieldset?.hasOnlyRadios();
      @if (labeledBy) {
        <span [id]="labeledBy" [class.required]="required">{{ label()! | translate }}</span>
      } @else {
        <label [for]="formItemId" [class.required]="required">{{ label()! | translate }}</label>
      }
      <ng-content select="[si-help-button]" />
    </div>
  }
</ng-template>
<ng-template #feedbackTemplate>
  @if (printErrors() && !fieldset?.hasOnlyRadios()) {
    <div class="invalid-feedback" [attr.id]="formItemErrormessageId">
      @for (error of errors(); track error.key) {
        <div>
          {{ error.message | translate: error.params }}
        </div>
      }
    </div>
  }
  <ng-content select=".warning-feedback, .info-feedback, .invalid-feedback" />
</ng-template>
<ng-template #content>
  <ng-content />
</ng-template>
